import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import { PAGE_URL } from "../services/constant";

const ApiKeyPermissionGroup = React.lazy(() =>
    import('../ApiKeyPermissionGroup')
);
const ApiKeyPermissionGroupDetails = React.lazy(() =>
    import('../ApiKeyPermissionGroupDetails')
);

const apiKeyPermissionGroupRoutesRegistry = [
    {
        path: PAGE_URL.API_KEY_PERMISSION_GROUP_PAGE,
        element: <ApiKeyPermissionGroup />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: `${PAGE_URL.API_KEY_PERMISSION_GROUP_PAGE}/:id`,
        element: <ApiKeyPermissionGroupDetails />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default apiKeyPermissionGroupRoutesRegistry;
